module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8edfbf9184bf3dd8e3588a0f9fc13a3c.png";